<script lang="ts">
	import { page } from '$app/stores';
	import { translations } from '$lib/i18n/translations';
	import type { Article, ArticleThumbnail, Property } from '$lib/satellite.types';
	import { getGravatarUrl } from '$lib/utils/ArticleHelper';
	import { DateFormatter } from '$lib/utils/DateFormatter';

	export let article: Article | ArticleThumbnail;
	export let description: boolean = false;
	export let alternate: boolean = false;

	const property = $page.data.property as Property;
	const t = translations(property.language);

	const datePublished = DateFormatter.since(article.published, property.language);
	const dateTime = article.published.toISOString();
	const author = article.author;
</script>

<!-- Byline -->
<div class="flex items-center">
	<ul class="list-none flex text-xs items-center">
		{#if article.anonymous}
			<li class="mr-2">
				<img
					src="/icon.svg"
					alt={property.name}
					class="w-5 h-5 rounded-full aspect-square"
					loading="lazy"
				/>
			</li>
			<li class={alternate ? '' : `after:content-['·'] after:mx-2`}>{property.name}</li>
		{:else}
			<li class="mr-2">
				<img
					src={getGravatarUrl(author.gravatarId, 40)}
					alt={author.name}
					class="w-5 h-5 rounded-full aspect-square"
					loading="lazy"
				/>
			</li>
			<li class={alternate ? '' : `after:content-['·'] after:mx-2`}>{author.name}</li>
		{/if}

		{#if !alternate}
			<li>
				<time datetime={dateTime} itemprop="datePublished">
					{datePublished}
				</time>
			</li>
		{/if}
	</ul>
</div>

<h3 class="text-lg leading-6 font-serif mt-3">
	{article.title}
</h3>

{#if description}
	<p class="text-sm mt-1">{article.description}</p>
{/if}

<!-- Category line -->
<ul class="list-none flex text-xs mt-3">
	{#if alternate}
		<li>
			<time datetime={dateTime} itemprop="datePublished">
				{datePublished}
			</time>
		</li>
	{:else}
		<li class="after:content-['·'] after:mx-2">
			{article.category?.name}
		</li>
		<li>
			{t(
				'byline_minutes',
				{
					minutes: article.readingTime.toString()
				},
				article.readingTime
			)}
		</li>
	{/if}
</ul>
